import Lottie from 'lottie-react';
import cn from 'classnames';
import { LoaderWhiteAnimation, LoaderAnimation } from 'assets/animations';
import styles from './Loader.module.css';

interface Props {
  isWhite?: boolean;
  className?: string;
}

const Loader = ({ className, isWhite = false }: Props): JSX.Element => (
  <Lottie
    animationData={isWhite ? LoaderWhiteAnimation : LoaderAnimation}
    className={cn(styles.loader, className)}
  />
);

export default Loader;
